module.exports = __webpack_public_path__ + "static/img/NewsImage1.e57fe2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/news/NewsImage1.png
// module id = jWyL
// module chunks = 1